import React from "react";
import "./Benes.css";
import {Button, Col, Container, Form, InputGroup, Modal, Row, Tab, Tabs} from "react-bootstrap";
import {
  APP_SECTION, BENE_RELATIONSHIPS_SELECT,
  BENEFICIARY, BENEFICIARY_SURVIVOR_UID,
  BENEFICIARY_TRUST, BENEFICIARY_TRUST_FIRST_NAME,
  BENEFICIARY_TYPE,
  benesForType, createContingentBeneficiary, createObjectForKeys,
  createPrimaryBeneficiary,
  ENTITY_TYPE, nameOfBene,
  numberOfBenes, PARTY,
  PARTY_RELATIONSHIPS_SELECT,
  totalAllocation,
  totalBenes
} from "../../../scripts/constants";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {deepCopy, isEqual, isValid, mygaSession} from "../../../scripts/myga-session";
import {saveApplication as syncApplication, saveApplication} from "../../../scripts/sync-manager";
import {v4 as uuidv4} from 'uuid';
import PopoverTooltip from "../../../components/PopoverTooltip";
import NSREDatePicker from "../../../components/NSREDatePicker";
import moment from "moment";
import {charLimits, formatting, NassauLog, regex} from "../../../scripts/myga-utils";
import Resources from "../../../Resources/Resources";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {
  hasContingentBenes,
  hasMinimumAllocations,
  hasPrimaryBenes, isContingentAllocationComplete,
  isPrimaryAllocationComplete,
  hasAnnuitant, hasSurvivingSpouseForPrimaryBene, isBeneValid
} from "../../../scripts/validation";
import {MM_PRODUCT_DTO} from "../../../scripts/myga-model";
import GENERATOR from "../../../selenium-front-end/generator/Generator";

class Benes extends React.Component {
  
  constructor(props) {
    super(props);
    // setup default prev/next pages with props overrides
    // this.prevPage = props.prevPage || PAGES.pageAppIdFinish; // 2021.07.14.ADivelbiss - commented in favor of PageManager page stack solution
    // this.nextPage = props.nextPage || PAGES.pageAppPayments; // 2021.07.15.ADivelbiss - commented in favor of PageManager getNextPage solution
    
    // Load the current application beneficiaries into the component state or initialize to empty array.
    let beneList = deepCopy(mygaSession.getCurrentAppBenes());
    
    // correct allocation errors prior to start
    if (
        this.numberOfBenes(BENEFICIARY_TYPE.primary, beneList) > 0 &&
        !isPrimaryAllocationComplete({[APP_SECTION.benes]: beneList})
    ) {
      this.resetAllocationsForBeneType(BENEFICIARY_TYPE.primary, beneList);
    }
    if (
        this.numberOfBenes(BENEFICIARY_TYPE.contingent, beneList) > 0 &&
        !isContingentAllocationComplete({[APP_SECTION.benes]: beneList})
    ) {
      this.resetAllocationsForBeneType(BENEFICIARY_TYPE.contingent, beneList);
    }
    
    // NassauLog(`beneList: ${JSON.stringify(beneList,null,2)}`
    // 20200505.ADivelbiss - this mechanism will pop-up the first bene that is not
    // in a valid state to help catch when the trust bene is added but without the
    // newly required taxID.
    let nextInvalid = this.nextInvalidBene(beneList);
    
    this.state = {
      benes: beneList,
      hasSurvivingSpouseForPrimaryBene: hasSurvivingSpouseForPrimaryBene(),
      showBeneModal: nextInvalid !== null,
      beneficiary: nextInvalid,
      isEdit: nextInvalid !== null,
      errorMessage: '',
      modalErrorMessage: ''
    }
    
    if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
      
      this.generateActionList = async () => {
        
        let actionList = [];
        
        const pushTestRemoveBene = (bene,index) => {
          if (bene===undefined || index<0) return;
          actionList.unshift(...[{
            type: 'click',
            id: `bene${bene[BENEFICIARY.beneficiaryType]}Remove_${index}`,
            stagedId: `bene${bene[BENEFICIARY.beneficiaryType]}Remove_${index}_${bene[BENEFICIARY.uid]}`
          }]);
        };
        
        const pushTestEditBene = (bene, index) => {
          if (bene===undefined || index<0) return;
          actionList.push(...[{
            type: 'click',
            id: `bene${bene[BENEFICIARY.beneficiaryType]}Edit_${index}`,
            stagedId: `bene${bene[BENEFICIARY.beneficiaryType]}Edit_${index}_${bene[BENEFICIARY.uid]}`
          }]);
        };
        
        const pushTestAddBene = (bene) => {
          if (!bene) return;
          actionList.push(...[{
            type: 'click',
            id: 'addBeneBtn',
            stagedId: `addBeneBtn_${bene[BENEFICIARY.uid]}`
          }]);
        };
        
        const pushTestFillBene = (bene) => {
          if (!bene) return;
          // Add the individual
          if (bene[BENEFICIARY.entityType] === ENTITY_TYPE.individual) {
            const dob = new Date(bene[BENEFICIARY.dob]);
            actionList.push(...[
              {
                type: 'click',
                id: 'tabIndividual',
                stagedId: `tabIndividual_${bene[BENEFICIARY.uid]}`
              },
              {
                type: 'keys',
                id: 'beneFirstName',
                stagedId: `beneFirstName_${bene[BENEFICIARY.uid]}`,
                value: bene[BENEFICIARY.firstName]
              },
              {
                type: 'keys',
                id: 'beneLastName',
                stagedId: `beneLastName_${bene[BENEFICIARY.uid]}`,
                value: bene[BENEFICIARY.lastName]
              },
              {
                type: 'click',
                id: `dob_month_${dob.getMonth() + 1}`,
                stagedId: `dob_month_${dob.getMonth() + 1}_${bene[BENEFICIARY.uid]}`,
              },
              {
                type: 'click',
                id: `dob_day_${dob.getDate()}`,
                stagedId: `dob_day_${dob.getDate()}_${bene[BENEFICIARY.uid]}`,
              },
              {
                type: 'click',
                id: `dob_year_${dob.getFullYear()}`,
                stagedId: `dob_year_${dob.getFullYear()}_${bene[BENEFICIARY.uid]}`,
              },
              {
                type: 'click',
                id: `relation_${bene[BENEFICIARY.relationshipToOwner]}`,
                stagedId: `relation_${bene[BENEFICIARY.relationshipToOwner]}_${bene[BENEFICIARY.uid]}`,
              },
              {
                type: 'click',
                id: bene[BENEFICIARY.gender] === 'Male' ? 'beneGenderMale' : 'beneGenderFemale',
                stagedId: (bene[BENEFICIARY.gender] === 'Male' ? 'beneGenderMale' : 'beneGenderFemale') + `_${bene[BENEFICIARY.uid]}`
              },
              {
                type: 'click',
                id: (bene[BENEFICIARY.beneficiaryType]===BENEFICIARY_TYPE.primary)?'beneTypePrimary':'beneTypeContingent',
                stagedId: (bene[BENEFICIARY.beneficiaryType]===BENEFICIARY_TYPE.primary)?'beneTypePrimary':'beneTypeContingent' + `_${bene[BENEFICIARY.uid]}`
              },
              {
                type: 'click',
                id: 'beneSaveBtn',
                stagedId: `beneSaveBtn_${bene[BENEFICIARY.uid]}`
              }
            ]);
          }
          // add the trust
          else if (bene[BENEFICIARY.entityType] === ENTITY_TYPE.trust) {
            const dob = new Date(bene[BENEFICIARY_TRUST.dateOfTrust]);
            actionList.push(...[
              {
                type: 'click',
                id: 'tabTrust',
                stagedId: `tabTrust_${bene[BENEFICIARY.uid]}`
              },
              {
                type: 'keys',
                id: 'beneTrustName',
                stagedId: `beneTrustName_${bene[BENEFICIARY.uid]}`,
                value: bene[BENEFICIARY_TRUST.trustName]
              },
              {
                type: 'click',
                id: `dob_month_${dob.getMonth() + 1}`,
                stagedId: `dob_month_${dob.getMonth() + 1}_${bene[BENEFICIARY.uid]}`,
              },
              {
                type: 'click',
                id: `dob_day_${dob.getDate()}`,
                stagedId: `dob_day_${dob.getDate()}_${bene[BENEFICIARY.uid]}`,
              },
              {
                type: 'click',
                id: `dob_year_${dob.getFullYear()}`,
                stagedId: `dob_year_${dob.getFullYear()}_${bene[BENEFICIARY.uid]}`,
              },
              {
                type: 'keys',
                id: 'beneTrustTaxID',
                stagedId: `beneTrustTaxID_${bene[BENEFICIARY.uid]}`,
                value: bene[BENEFICIARY_TRUST.taxId]
              },
              {
                type: 'click',
                id: (bene[BENEFICIARY.beneficiaryType]===BENEFICIARY_TYPE.primary)?'beneTypePrimaryTrust':'beneTypeContingentTrust',
                stagedId: (bene[BENEFICIARY.beneficiaryType]===BENEFICIARY_TYPE.primary)?'beneTypePrimaryTrust':'beneTypeContingentTrust' + `_${bene[BENEFICIARY.uid]}`
              },
              {
                type: 'click',
                id: 'beneSaveBtn',
                stagedId: `beneSaveBtn_${bene[BENEFICIARY.uid]}`
              }
            ]);
          }
          // unknown type
          else {
            // nothing to do
          }
        };

        // splits the bene array into primary and contingent sub-arrays
        const splitByType = (benes) => {
          return [
            this.benesForType(BENEFICIARY_TYPE.primary,benes),
            this.benesForType(BENEFICIARY_TYPE.contingent,benes)
          ];
        };
        
        // get the indes for the given bene from the given benes array
        const indexForBene = (bene, benes) => benes.findIndex(b=>b[BENEFICIARY.uid]===bene[BENEFICIARY.uid]);
        
        // get the initial and next benes
        const initBenes = mygaSession.getCurrentAppBenes();
        const nextBenes = this.state.benes;
  
        // check for any changes
        if (isEqual(initBenes,nextBenes)) return;
        NassauLog('benes changed');
        NassauLog(`initBenes: ${JSON.stringify(initBenes,null,2)}`);
        NassauLog(`nextBenes: ${JSON.stringify(nextBenes,null,2)}`);
  
        // Check for an invalid initial bene.  If it exists then the page starts with the modal open
        // add the missing information.  This must be done before any other operation .
        const invalidBene = this.nextInvalidBene(initBenes);
        if (invalidBene) {
          // get this invalid initial bene from the next bene list
          const validBene = nextBenes.find(b=>b[BENEFICIARY.uid]===invalidBene[BENEFICIARY.uid]);
          if (validBene) {
            pushTestFillBene(validBene);
          }
        }

        // Split the initial benes into primary and contingent groups
        const initBeneTypes = splitByType(initBenes);
  
        // Handle benes to be removed
        const toRemove = initBenes.filter(b=>indexForBene(b,nextBenes)<0);
        splitByType(toRemove).forEach((benes,beneType)=>{
          benes.forEach((bene)=>{
            pushTestRemoveBene(bene,indexForBene(bene,initBeneTypes[beneType]));
          });
        });
        
        // Handle benes to be edited
        const toEdit = initBenes.filter((initBene)=>{
          const nextBene = nextBenes.find(b=>b[BENEFICIARY.uid]===initBene[BENEFICIARY.uid]);
          // check that the bene is in both lists, that the original was valid, and that the bene changed.
          return (nextBene!==undefined) && isBeneValid(initBene) && !isEqual(nextBene,initBene);
        });
        splitByType(toEdit).forEach((benes,beneType)=>{
          benes.forEach((bene)=>{
            pushTestEditBene(bene,indexForBene(bene,initBeneTypes[beneType]));
            pushTestFillBene(bene);
          });
        });
        
        // Handle benes to be added
        const toAdd = nextBenes.filter(b=>indexForBene(b,initBenes)<0);
        splitByType(toAdd).forEach((benes,beneType)=>{
          benes.forEach((bene)=>{
            pushTestAddBene(bene);
            pushTestFillBene(bene);
          });
        });
        
         // Handle final bene allocations
        splitByType(nextBenes).forEach((benes,beneType)=>{
          // do not set the last bene allocation since it will be computed based on the other values
          for (let i=0; i<benes.length-1; i++) {
            const bene = benes[i];
            if (this.isBeneSurvivngSpouse(bene)) return;
            actionList.push(
                {
                  type: 'keys',
                  id: `${BENEFICIARY.allocation}${bene[BENEFICIARY.beneficiaryType]}_${i}`,
                  value: bene[BENEFICIARY.allocation]
                }
            );
          }
        });
        
        await GENERATOR.stageManualActionList(actionList)
      }
    }
  }
  
  /**
   * Returns the next invalid bene
   */
  nextInvalidBene = (benes) => {
    const invalidBenes = benes.filter(bene=>!isBeneValid(bene));
    NassauLog(`invalidBenes: ${JSON.stringify(invalidBenes,null,2)}`);
    return invalidBenes.length>0?invalidBenes[0]:null;
  }
  
  /**
   * Make a bene object for the given type
   */
  makeBene = () => {
    let bene = this.state.hasSurvivingSpouseForPrimaryBene ? createContingentBeneficiary() : createPrimaryBeneficiary();
    bene[BENEFICIARY.uid] = uuidv4();
    return bene;
  };
  
  saveApplication = async () => {
    NassauLog("Benes.saveApplication");
    
    // TODO: populate benes object from fields
    // Use the component state to update the array of beneficiaries.
    // if (this.state.benes.length > 0) {
    
    // let app = mygaSession.getCurrentApp();
    // NassauLog(JSON.stringify(app));
    
    // Update the current application
    mygaSession.setCurrentAppSectionData(APP_SECTION.benes, this.state.benes);
    
    // save the application
    await saveApplication(APP_SECTION.benes);
    
    // 2022.05.19.ADivelbiss - currently assume all parties applied to all selected products.
    const nextProductDTOs = [...mygaSession.getCurrentAppProductDTOs()];
    nextProductDTOs.forEach(dto=>dto[MM_PRODUCT_DTO.benes]=this.state.benes);
    mygaSession.setCurrentAppProductDTOs(nextProductDTOs)
    await syncApplication(APP_SECTION.products);
    // }
  };
  
  onBackPressed = async () => {
    if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
      await this.generateActionList()
    }
    await this.saveApplication()
  }
  
  onNextPressed = async () => {
    if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
      await this.generateActionList()
    }
    await this.saveApplication()
  }
  
  newBene = () => this.setState({showBeneModal: true, beneficiary: this.makeBene()});
  hideBene = () => this.setState({showBeneModal: false, modalErrorMessage:''});
  
  headerStyles = {
    backgroundColor: 'rgba(242, 193, 102, 0.25)',
    width: '100%',
    fontSize: '1.5em',
    marginTop: '20px'
  };
  
  tableStyle = {
    backgroundColor: 'rgba(242, 193, 102, 0.25)',
    //width: '100%'
  };
  
  nameColumnStyle = {
    width: '50%'
  };
  
  allocationColumnStyle = {
    width: '25%'
  };
  
  relationshipColumnStyle = {
    width: '25%'
  };
  
  handleChange = (field) => (e) => {
    let bene = this.state.beneficiary;
    bene[field] = e.target ? e.target.value : e;
    if (field === BENEFICIARY.entityType){
      if (bene[field] === ENTITY_TYPE.individual){
        if (bene[BENEFICIARY.firstName] === BENEFICIARY_TRUST_FIRST_NAME){
          bene[BENEFICIARY.firstName] = "";
          bene[BENEFICIARY.relationshipToOwner] = "";
        }
      }
    }
    // if the entity type changes, do a conversion
    // if (field === BENEFICIARY.entityType) {
    //     if (bene[field] === ENTITY_TYPE.trust) {
    //         let newBene = createObjectForKeys(BENEFICIARY_TRUST, bene);
    //         newBene[BENEFICIARY_TRUST.trustName] = bene[BENEFICIARY.firstName];
    //         newBene[BENEFICIARY.firstName] = BENEFICIARY_TRUST_FIRST_NAME;
    //         bene = newBene;
    //     } else {
    //         let newBene = createObjectForKeys(BENEFICIARY, bene);
    //         newBene[BENEFICIARY.firstName] = bene[BENEFICIARY_TRUST.trustName];
    //         bene = newBene;
    //     }
    //     // NassauLog(`bene entity type change: ${field}, ${JSON.stringify(bene,null,2)}`)
    // }
    this.setState({beneficiary: bene, errorMessage: '', modalErrorMessage: ''});
  };
  
  handleAllocationChange = (bene) => (e) => {
    let nextBenes = [...this.state.benes];
    const beneType = bene[BENEFICIARY.beneficiaryType];
    let benes = nextBenes.filter(bene => (bene[BENEFICIARY.beneficiaryType] === beneType));
    let index = benes.findIndex((b) => (b.uid === bene.uid));
    let maxAlloc = benes.length > 1 ? 99 : 100;
    let minAlloc = 1;
    benes[index][BENEFICIARY.allocation] = Math.min(maxAlloc, Math.max(minAlloc, e.target.value));
    if (benes.length === 2) {
      let other = index > 0 ? 0 : 1;
      benes[other][BENEFICIARY.allocation] = 100 - benes[index][BENEFICIARY.allocation];
    } else {
      let count = benes.length - (index + 1);
      if (count > 0) {
        let total = 100;
        for (let i = 0; i <= index; i++) {
          total -= benes[i][BENEFICIARY.allocation];
        }
        if (total < count) {
          benes[index][BENEFICIARY.allocation] += (total - count);
          total = count;
        }
        const allocation = Math.round(total / count);
        for (let i = index + 1; i < benes.length; i++) {
          total -= allocation;
          benes[i][BENEFICIARY.allocation] = allocation;
        }
        benes[index + 1][BENEFICIARY.allocation] = Math.round(benes[index + 1][BENEFICIARY.allocation] + total);
      } else {
        let other = index - 1;
        let total = 1;
        for (let i = 0; i < other; i++) {
          total -= benes[i][BENEFICIARY.allocation];
        }
        if (total - benes[index][BENEFICIARY.allocation] < 1) {
          benes[index][BENEFICIARY.allocation] = total - 1;
        }
        benes[other][BENEFICIARY.allocation] = total - benes[index][BENEFICIARY.allocation];
      }
    }
    this.setState({benes: nextBenes});
  };
  
  removeBene(bene) {
    
    // Find the index of the id
    let index = this.state.benes.findIndex((b) => (b.uid === bene.uid));
    if (index >= 0) {
      let nextBenes = [...this.state.benes];
      let toRemove = nextBenes[index];
      nextBenes.splice(index, 1);
      
      // update the allocation
      const beneType = toRemove[BENEFICIARY.beneficiaryType];
      this.resetAllocationsForBeneType(beneType, nextBenes);
      
      this.setState({benes: nextBenes});
    }
    
  }
  
  editBene(bene) {
    
    this.setState({
      showBeneModal: true,
      isEdit: true,
      beneficiary: Object.assign({}, bene),
    });
    
  }
  
  saveBene() {
    
    // get reference to the bene
    let bene = this.state.beneficiary;
    
    // Need to validate the bene from
    if (!this.beneForm.checkValidity()) {
      this.beneForm.classList.add('was-validated');
      // check for taxID
      if (this.taxId && !this.taxId.checkValidity()) {
        this.setState({
          modalErrorMessage: MYGAStrings.BenesTrust_TaxIDInvalid
        });
      }
      return;
    }
    
    // check the current bene
    if (new Date(bene[BENEFICIARY.dob]) > new Date()) {
      let message = 'Date of birth cannot be in the future.';
      if (bene[BENEFICIARY.entityType] === ENTITY_TYPE.trust) {
        message = 'Date of Trust cannot be in the future.';
      }
      this.beneDOB.setCustomValidity(message);
      this.beneForm.classList.add('was-validated');
      this.setState({
        modalErrorMessage: message
      });
      return false;
    } else {
      this.beneDOB.setCustomValidity('');
    }
    
    // Validate TaxID for Bene Trusts
    if (bene[BENEFICIARY.entityType] === ENTITY_TYPE.trust) {
      // NassauLog("#We've entered");
      let tempBeneList = [...this.state.benes];
      if (tempBeneList.filter(b=>{return (b[BENEFICIARY_TRUST.uid] === bene[BENEFICIARY_TRUST.uid]);}).length === 0)
      {
        tempBeneList.push(bene);
      }
      let tempBeneListLength = tempBeneList.length;
      // NassauLog(`Bene List Length: ${tempBeneListLength}`);
      if(tempBeneListLength > 1) {
        let taxCount = tempBeneList.reduce((count, b) => {
          return count + (b[BENEFICIARY_TRUST.taxId] === bene[BENEFICIARY_TRUST.taxId] ? 1 : 0);
        }, 0);
        // NassauLog(`Tax Count: ${taxCount}`);
        if (taxCount > 1) {
          // NassauLog("We have a tax problem");
          this.taxId.setCustomValidity('invalid');
          this.beneForm.classList.add('was-validated');
          this.setState({
            modalErrorMessage: MYGAStrings.BenesTrust_TaxIDInUse
          });
          return false;
        }
      }
    }
    
    if (bene[BENEFICIARY.entityType] === ENTITY_TYPE.trust) {
      let newBene = createObjectForKeys(BENEFICIARY_TRUST, bene);
      newBene[BENEFICIARY.firstName] = BENEFICIARY_TRUST_FIRST_NAME;
      bene = newBene;
    } else {
      let newBene = createObjectForKeys(BENEFICIARY, bene);
      bene = newBene;
    }
    
    // get a copy of the current benes
    let nextBenes = ([...this.state.benes] || []);
    
    //If its an edit, lets change the item in the array
    if (this.state.isEdit) {
      
      // Find the index of the id
      let index = nextBenes.findIndex((b) => (b.uid === bene.uid));
      nextBenes[index] = bene;
      
      // check to see if the number of primary (contingent) benes changed and if so reset allocation
      if (this.numberOfBenes(BENEFICIARY_TYPE.primary) !== this.numberOfBenes(BENEFICIARY_TYPE.primary, nextBenes)) {
        this.resetAllocationsForBeneType(BENEFICIARY_TYPE.primary, nextBenes);
        this.resetAllocationsForBeneType(BENEFICIARY_TYPE.contingent, nextBenes);
      }
      
    } else { //Its a new item, just push it
      
      nextBenes.push(bene);
      
      // update the allocation
      const beneType = bene[BENEFICIARY.beneficiaryType];
      this.resetAllocationsForBeneType(beneType, nextBenes);
    }
    
    this.setState({
          benes: nextBenes,
          showBeneModal: false,
          isEdit: false
        }
    );
  }
  
  resetAllocationsForBeneType(beneType, inBenes = this.state.benes) {
    let benes = this.benesForType(beneType, inBenes);
    if (benes.length > 0) {
      const allocation = Math.round(100 / benes.length);
      let total = 100;
      for (let i = 0; i < benes.length; i++) {
        total -= allocation;
        benes[i][BENEFICIARY.allocation] = allocation;
      }
      benes[0][BENEFICIARY.allocation] += total;
    }
  }
  
  
  benesForType = (beneType, benes = this.state.benes) => benesForType(beneType, benes);
  
  numberOfBenes = (beneType, benes = this.state.benes) => numberOfBenes(beneType, benes);
  
  totalBenes = (benes = this.state.benes) => totalBenes(benes);
  
  totalAllocation = (beneType, benes = this.state.benes) => totalAllocation(beneType, benes);
  
  isBeneSurvivngSpouse = (bene) => {
    return bene[BENEFICIARY.uid] === BENEFICIARY_SURVIVOR_UID;
  }
  
  hasContingentBenes = () => {
    return hasContingentBenes({[APP_SECTION.benes]: this.state.benes});
  };
  
  relationshipOfBene = (bene) =>  {
    return (isValid(bene[BENEFICIARY.relationshipToOwner]) && (bene[BENEFICIARY.relationshipToOwner].length > 0) ? bene[BENEFICIARY.relationshipToOwner] : 'not applicable')
  }
  
  // ssnCount = this.benes.reduce((count,p)=>{
  //     return count + (p[PARTY.ssnOrTaxId]===party()[PARTY.ssnOrTaxId] ? 1 : 0);
  // },0);
  // if (ssnCount>1) {
  // ssnInput.current.setCustomValidity('invalid');
  // pageForm.current.classList.add('was-validated');
  // errorMessage.current = MYGAStrings.IdDataEntry_SsnOrTaxIdInUse;
  // return false;
  // }
  
  renderTaxIdField = () => {
    return <Form.Control
        ref={(el)=> {
          this.taxId=el
        }}
        className="page-input"
        type="text"
        required
        id="beneTrustTaxID"
        name="taxId"
        maxLength={charLimits.tin}
        pattern={regex.tin}
        value={this.state.beneficiary[BENEFICIARY_TRUST.taxId]}
        onChange={this.handleChange(BENEFICIARY_TRUST.taxId)}
        placeholder="Tax ID"/>
  }
  
  validate = () => {
    
    // 20220505.ADivelbiss - check for any invalid bene
    let nextInvalid = this.nextInvalidBene(this.state.benes);
    if (nextInvalid!==null) {
      this.editBene(nextInvalid);
      return false;
    }
    
    // 2021.07.16.ADivelbiss - onNext Validation
    //No Primary Bene
    if (!hasPrimaryBenes({[APP_SECTION.benes]: this.state.benes})) {
      this.setState({
        errorMessage: MYGAStrings.Benes_ErrorNoPrimary
      });
      return false;
    }
    
    // All benes must have a non-zero allocation
    if (!hasMinimumAllocations({[APP_SECTION.benes]: this.state.benes})) {
      this.setState({
        errorMessage: MYGAStrings.Benes_ErrorAllocationCannotBeZero
      });
      return false;
    }
    
    // Primary benes must add up to 100
    if (!isPrimaryAllocationComplete({[APP_SECTION.benes]: this.state.benes})) {
      this.setState({
        errorMessage: MYGAStrings.Benes_ErrorPrimaryAllocationNot100
      });
      return false;
    }
    
    // Primary benes must add up to 100
    if (this.hasContingentBenes() && !isContingentAllocationComplete({[APP_SECTION.benes]: this.state.benes})) {
      this.setState({
        errorMessage: MYGAStrings.Benes_ErrorAddedContingentAllocationNot100
      });
      return false;
    }
    if (this.totalBenes()>4) {
      this.setState({
        errorMessage: MYGAStrings.Benes_ErrorMoreThan4Benes
      });
      return false;
    }
    
    // clear the error message
    this.setState({
      errorMessage: ''
    });
    
    return true;
  };
  // end validate
  
  renderBeneTooltip = (benesForType) => {
    if (!benesForType?.length || benesForType?.length !== 1) return;
    return <PopoverTooltip content={MYGAStrings.Benes_Tooltip}/>
  }
  //<Col className="my-auto name" xs={4}>{nameOfBene(bene)}</Col>
  //       <Col className="my-auto relationship " sm={4}>{this.relationshipOfBene(bene)}</Col>
  //       <Col className="my-auto allocation " xs={4} sm={4}>
  renderBeneficiary = (bene, index, disabled, max) => (
      <Row key={index} className="page-data-entry border-bottom align-content-center">
        <Col className="my-auto name align-content-center" xs={4} sm={5} md={4}>{nameOfBene(bene)}&nbsp;
          <PopoverTooltip className="d-inline-block d-md-none" icon={'ellipsis-h'} content={
            <div>
              <p><b>Relationship:</b> {this.relationshipOfBene(bene)}</p>
            </div>
          }/>
        </Col>
        <Col className="my-auto relationship d-none d-md-block"  md={3}>{this.relationshipOfBene(bene)}</Col>
        <Col className="my-auto allocation " xs={4} sm={3} md={2}>
          <InputGroup>
            <Form.Control required
                          type="number"
                          className="page-input allocation-input"
                          disabled={disabled}
                          min={1}
                          max={max}
                          id={`${BENEFICIARY.allocation}${bene[BENEFICIARY.beneficiaryType]}_${index}`}
                          name={BENEFICIARY.allocation}
                          value={Math.round(bene[BENEFICIARY.allocation])}
                          onChange={this.handleAllocationChange(bene)}
                          placeholder=""/>
            <InputGroup.Append>
              <InputGroup.Text
                  className="pl-1 pr-1">%</InputGroup.Text>
            </InputGroup.Append>
          </InputGroup>
        </Col>
        <Col className="my-auto text-center pl-1 pr-1 pl-md-4 pr-md-4" >
          {
              !this.isBeneSurvivngSpouse(bene) &&
              (
                  <Button id={`bene${bene[BENEFICIARY.beneficiaryType]}Edit_${index}`} className={'btn-edit-remove myga-edit'}
                          onClick={() => this.editBene(bene)}>
                    <FontAwesomeIcon icon={Resources.Icons.Pencil}/>
                  </Button>
              )
          }
        </Col>
        <Col className="my-auto text-center pl-1 pr-1 pl-md-4 pr-md-4" >
          {
              !this.isBeneSurvivngSpouse(bene) &&
              (
                  <Button id={`bene${bene[BENEFICIARY.beneficiaryType]}Remove_${index}`} className={'btn-edit-remove myga-trash'}
                          onClick={() => this.removeBene(bene)}>
                    <FontAwesomeIcon icon={Resources.Icons.TrashCan}/>
                  </Button>
              )
          }
        </Col>
      </Row>
  )
  
  renderPrimaryBenes = () => {
    let disabled = this.numberOfBenes(BENEFICIARY_TYPE.primary) < 2;
    let inputMax = this.numberOfBenes(BENEFICIARY_TYPE.primary) > 1 ? 99 : 100;
    return this.benesForType(BENEFICIARY_TYPE.primary)
        .map((bene, index) => this.renderBeneficiary(bene, index, disabled, inputMax))
  }
  
  renderContingentBenes = () => {
    let disabled = this.numberOfBenes(BENEFICIARY_TYPE.contingent) < 2;
    let inputMax = this.numberOfBenes(BENEFICIARY_TYPE.contingent) > 1 ? 99 : 100
    return this.benesForType(BENEFICIARY_TYPE.contingent)
        .map((bene, index) => this.renderBeneficiary(bene, index, disabled, inputMax))
  }
  
  renderBenesTable = (name, beneTooltip, benes, totalAllocation) => {
    return (
        <div className="bene-table mb-3">
          <Row className="header border-bottom">
            <Col className="name" xs={4} sm={5} md={4}>{name}</Col>
            <Col className="relationship d-none d-md-block" md={3}>Relationship</Col>
            <Col className="allocation" xs={4} md={3}>Benefits
              &nbsp;{beneTooltip}
            </Col>
            <Col/>
            <Col/>
          </Row>
          
          {benes}
          
          <Row className={'footer'}>
            <Col className="name" xs={4} sm={5} md={4}/>
            <Col className="relationship d-none d-md-block" md={3}/>
            <Col className="allocation" xs={4} md={3}>{totalAllocation}%</Col>
            <Col/>
            <Col/>
          </Row>
        </div>
    )
  }
  
  renderPrimaryBenesTable = () => {
    let name = 'Primary';
    let beneTooltip = this.renderBeneTooltip(this.benesForType(BENEFICIARY_TYPE.primary));
    let benes = this.renderPrimaryBenes();
    let totalAllocation = this.totalAllocation(BENEFICIARY_TYPE.primary);
    return this.renderBenesTable(name, beneTooltip, benes, totalAllocation)
  }
  
  renderContingentBenesTable = () => {
    if (!this.hasContingentBenes()) return;
    let name = 'Contingent';
    let beneTooltip = this.renderBeneTooltip(this.benesForType(BENEFICIARY_TYPE.contingent));
    let benes = this.renderContingentBenes();
    let totalAllocation = this.totalAllocation(BENEFICIARY_TYPE.contingent);
    return this.renderBenesTable(name, beneTooltip, benes, totalAllocation)
  }
  
  render() {
    
    return (
        
        <AppContentWrapper
            onBackPressed={this.onBackPressed}
            onNextPressed={this.onNextPressed}
            validateOnNext={this.validate}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}>
          
          <Container>
            {
                this.state.hasSurvivingSpouseForPrimaryBene && (
                    <Row className="text-center pt-2 pb-3">
                      <Col sm={{span:10, offset:1}} className="text-left " >
                        <div className={'font-page-small'}>{MYGAStrings.Benes_SurvivingSpouseInfo}</div>
                      </Col>
                    </Row>
                )
            }
            
            {this.renderPrimaryBenesTable()}
            {this.renderContingentBenesTable()}
            
            {
                this.totalBenes() < 4 && (
                    <Row className="text-center pt-3">
                      <Col>
                        <Button id={'addBeneBtn'} className={'nsre-button add-button'} variant="primary" onClick={this.newBene}>
                          ADD
                        </Button>
                      </Col>
                    </Row>
                )
            }
          </Container>
          
          {
              this.state.beneficiary!=null && (
                  <Modal
                      size="lg"
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                      show={this.state.showBeneModal}
                      onHide={this.hideBene}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Beneficiary Info</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pb-0 pl-sm-1 pr-sm-1">
                      <form className={'needs-validation'}
                            ref={(form) => {
                              this.beneForm = form;
                            }}>
                        
                        <Tabs
                            activeKey={this.state.beneficiary[BENEFICIARY.entityType]}
                            onSelect={this.handleChange(BENEFICIARY.entityType)}>
                          
                          {/* HANDLE INDIVIDUAL BENE INPUT */}
                          <Tab id={"tabIndividual"} eventKey={ENTITY_TYPE.individual} title={'Individual'}>
                            {
                                this.state.beneficiary[BENEFICIARY.entityType] === ENTITY_TYPE.individual && (
                                    <>
                                      <Row className="page-data-entry">
                                        <Col sm={6} className="pb-3 pb-sm-0">
                                          <Form.Label className="px-0 mb-0">First Name</Form.Label>
                                          <Form.Control
                                              className="page-input"
                                              type="text"
                                              required
                                              id="beneFirstName"
                                              name="firstName"
                                              value={this.state.beneficiary[BENEFICIARY.firstName]}
                                              onChange={this.handleChange(BENEFICIARY.firstName)}
                                              placeholder="First Name"/>
                                        </Col>
                                        <Col sm={6} className="pb-3 pb-sm-0">
                                          <Form.Label className="px-0 mb-0">Last Name</Form.Label>
                                          <Form.Control
                                              type="text"
                                              required
                                              className="page-input"
                                              id="beneLastName"
                                              name="lastName"
                                              value={this.state.beneficiary[BENEFICIARY.lastName]}
                                              onChange={this.handleChange(BENEFICIARY.lastName)}
                                              placeholder="Last Name"/>
                                        </Col>
                                      </Row>
                                      <Row className="page-data-entry">
                                        <Col sm={6} className="pb-3 pb-sm-0">
                                          <Form.Label className="px-0 mb-0">Date Of Birth</Form.Label>
                                          <NSREDatePicker
                                              ref={(el) => {
                                                this.beneDOB = el;
                                              }}
                                              className={'form-control page-input'}
                                              required
                                              yearOrderAscending={false}
                                              value={this.state.beneficiary[BENEFICIARY.dob]}
                                              onChange={(value) => {
                                                this.beneDOB.setCustomValidity('');
                                                this.handleChange(BENEFICIARY.dob)(value)
                                              }}
                                              onClick={(value) => {
                                                this.beneDOB.setCustomValidity('');
                                                this.handleChange(BENEFICIARY.dob)(value)
                                              }}
                                              
                                              minDate={moment().subtract(120, "years").toDate()}
                                              maxDate={moment().toDate()}
                                              name={BENEFICIARY.dob}
                                              dataFormat={formatting.dob}
                                              placeholder="Date of Birth"
                                          />
                                          {/*<Form.Control className="page-input"*/}
                                          {/*              required*/}
                                          {/*              type="date"*/}
                                          {/*              value={this.state.beneficiary[BENEFICIARY.dob]}*/}
                                          {/*              onChange={this.handleChange(BENEFICIARY.dob)}*/}
                                          {/*              name={ID_DATA_ENTRY.dob}*/}
                                          {/*              data-format="MM-DD-YYYY"*/}
                                          {/*              data-template="MMM D YYYY"*/}
                                          {/*              placeholder="Date of Birth" />*/}
                                        </Col>
                                        <Col sm={6} className="pb-3 pb-sm-0">
                                          <Form.Label className="px-0 mb-0">Relationship To Owner</Form.Label>
                                          <Form.Control
                                              className="page-select"
                                              required
                                              as="select"
                                              value={this.state.beneficiary[BENEFICIARY.relationshipToOwner]}
                                              onChange={this.handleChange(BENEFICIARY.relationshipToOwner)}>
                                            <option disabled value="">Make a Selection</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.spouse}`} value={BENE_RELATIONSHIPS_SELECT.spouse}>Spouse</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.civilUnionPartner}`} value={BENE_RELATIONSHIPS_SELECT.civilUnionPartner}>Civil Union Partner</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.child}`} value={BENE_RELATIONSHIPS_SELECT.child}>Child</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.family}`} value={BENE_RELATIONSHIPS_SELECT.family}>Family</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.fiancee}`} value={BENE_RELATIONSHIPS_SELECT.fiancee}>Fiancee</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.grandchild}`} value={BENE_RELATIONSHIPS_SELECT.grandchild}>Grandchild</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.grandfather}`} value={BENE_RELATIONSHIPS_SELECT.grandfather}>Grandfather</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.grandmother}`} value={BENE_RELATIONSHIPS_SELECT.grandmother}>Grandmother</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.parent}`} value={BENE_RELATIONSHIPS_SELECT.parent}>Parent</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.brother}`} value={BENE_RELATIONSHIPS_SELECT.brother}>Brother</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.sister}`} value={BENE_RELATIONSHIPS_SELECT.sister}>Sister</option>
                                            <option id={`relation_${BENE_RELATIONSHIPS_SELECT.other}`} value={BENE_RELATIONSHIPS_SELECT.other}>Other</option>
                                          </Form.Control>
                                        </Col>
                                      </Row>
                                      <Row className="page-data-entry">
                                        <Col sm={6} className="pb-3 pb-sm-0">
                                          <Form.Label className="px-0 mb-0">Gender</Form.Label>
                                          <Row className="pl-0 pr-0">
                                            <Col xs={6} className="pl-0 pr-0">
                                              <div className='form-check form-check-inline '>
                                                <input required type="radio" className="form-check-input"
                                                       id="beneGenderMale"
                                                       name={BENEFICIARY.gender}
                                                       checked={this.state.beneficiary[BENEFICIARY.gender] === 'Male'}
                                                       onClick={this.handleChange(BENEFICIARY.gender)}
                                                       onChange={() => {
                                                       }}
                                                       value="Male"/>
                                                <label className="form-check-label"
                                                       htmlFor="beneGenderMale">Male</label>
                                              </div>
                                            </Col>
                                            <Col xs={6} className="pl-0 pr-0">
                                              <div className='form-check form-check-inline '>
                                                <input required type="radio" className="form-check-input"
                                                       id="beneGenderFemale"
                                                       name={BENEFICIARY.gender}
                                                       checked={this.state.beneficiary[BENEFICIARY.gender] === 'Female'}
                                                       onClick={this.handleChange(BENEFICIARY.gender)}
                                                       onChange={() => {
                                                       }}
                                                       value="Female"/>
                                                <label className="form-check-label"
                                                       htmlFor="beneGenderFemale">Female</label>
                                              </div>
                                            </Col>
                                          </Row>
                                        </Col>
                                        <Col sm={6} className="pb-0 pb-sm-0">
                                          <Form.Label className="px-0 mb-0">Type of Beneficiary</Form.Label>
                                          <Row className="pl-0 pr-0">
                                            <Col xs={6} className="pl-0 pr-0">
                                              <div className='form-check form-check-inline '>
                                                <input required type="radio" className="form-check-input"
                                                       id="beneTypePrimary"
                                                       name={BENEFICIARY.beneficiaryType}
                                                       disabled={this.state.hasSurvivingSpouseForPrimaryBene}
                                                       checked={this.state.beneficiary[BENEFICIARY.beneficiaryType] === 'Primary'}
                                                       onClick={this.handleChange(BENEFICIARY.beneficiaryType)}
                                                       onChange={() => {
                                                       }}
                                                       value="Primary"/>
                                                <label className="form-check-label"
                                                       htmlFor="beneTypePrimary">Primary</label>
                                              </div>
                                            </Col>
                                            <Col xs={6} className="pl-0 pr-0">
                                              <div className='form-check form-check-inline '>
                                                <input required type="radio" className="form-check-input"
                                                       id="beneTypeContingent"
                                                       name={BENEFICIARY.beneficiaryType}
                                                       checked={this.state.beneficiary[BENEFICIARY.beneficiaryType] === 'Contingent'}
                                                       onClick={this.handleChange(BENEFICIARY.beneficiaryType)}
                                                       onChange={() => {
                                                       }}
                                                       value="Contingent"/>
                                                <label className="form-check-label"
                                                       htmlFor="beneTypeContingent">Contingent</label>
                                              </div>
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    </>
                                )
                            }
                          </Tab>
                          
                          {/* HANDLE TRUST BENE INPUT */}
                          <Tab id={"tabTrust"} eventKey={ENTITY_TYPE.trust} title={'Trust'}>
                            {
                                this.state.beneficiary[BENEFICIARY.entityType] === ENTITY_TYPE.trust && (
                                    <>
                                      <Row className="page-data-entry">
                                        <Col className="pb-3 pb-sm-0">
                                          <Form.Label className="px-0 mb-0">First Name</Form.Label>
                                          <Form.Control
                                              className="page-input"
                                              type="text"
                                              required
                                              id="beneTrustName"
                                              name="trustName"
                                              value={this.state.beneficiary[BENEFICIARY_TRUST.trustName]}
                                              onChange={this.handleChange(BENEFICIARY_TRUST.trustName)}
                                              placeholder="Trust Name"/>
                                        </Col>
                                      </Row>
                                      <Row className="page-data-entry">
                                        <Col className="pb-3 pb-sm-0">
                                          <Form.Label className="px-0 mb-0">Date Of Trust</Form.Label>
                                          <NSREDatePicker
                                              ref={(el) => {
                                                this.beneDOB = el;
                                              }}
                                              className={'form-control page-input'}
                                              required
                                              yearOrderAscending={false}
                                              value={this.state.beneficiary[BENEFICIARY_TRUST.dateOfTrust]}
                                              onChange={(value) => {
                                                this.beneDOB.setCustomValidity('');
                                                this.handleChange(BENEFICIARY_TRUST.dateOfTrust)(value)
                                              }}
                                              onClick={(value) => {
                                                this.beneDOB.setCustomValidity('');
                                                this.handleChange(BENEFICIARY_TRUST.dateOfTrust)(value)
                                              }}
                                              
                                              minDate={moment().subtract(120, "years").toDate()}
                                              maxDate={moment().toDate()}
                                              name={BENEFICIARY_TRUST.dateOfTrust}
                                              dataFormat={formatting.dob}
                                              placeholder="Date of Trust"
                                          />
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col className="pb-3 pb-sm-0">
                                          <Form.Label className="px-0 mb-0">Tax ID <span className={'text-small'}>(xx-xxxxxxx)</span></Form.Label>
                                          {this.renderTaxIdField()}
                                        </Col>
                                      </Row>
                                      <Row className="page-data-entry">
                                        <Col className="pb-0 pb-sm-0">
                                          <Form.Label className="px-0 mb-0">Type of Beneficiary</Form.Label>
                                          <Row className="pl-0 pr-0">
                                            <Col xs={6} className="pl-0 pr-0">
                                              <div className='form-check form-check-inline '>
                                                <input required type="radio" className="form-check-input"
                                                       id="beneTypePrimaryTrust"
                                                       name={BENEFICIARY.beneficiaryType}
                                                       disabled={this.state.hasSurvivingSpouseForPrimaryBene}
                                                       checked={this.state.beneficiary[BENEFICIARY.beneficiaryType] === 'Primary'}
                                                       onClick={this.handleChange(BENEFICIARY.beneficiaryType)}
                                                       onChange={() => {
                                                       }}
                                                       value="Primary"/>
                                                <label className="form-check-label"
                                                       htmlFor="beneTypePrimaryTrust">Primary</label>
                                              </div>
                                            </Col>
                                            <Col xs={6} className="pl-0 pr-0">
                                              <div className='form-check form-check-inline '>
                                                <input required type="radio" className="form-check-input"
                                                       id="beneTypeContingentTrust"
                                                       name={BENEFICIARY.beneficiaryType}
                                                       checked={this.state.beneficiary[BENEFICIARY.beneficiaryType] === 'Contingent'}
                                                       onClick={this.handleChange(BENEFICIARY.beneficiaryType)}
                                                       onChange={() => {
                                                       }}
                                                       value="Contingent"/>
                                                <label className="form-check-label"
                                                       htmlFor="beneTypeContingentTrust">Contingent</label>
                                              </div>
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    </>
                                )
                            }
                          </Tab>
                        </Tabs>
                        
                        
                        {
                            this.state.modalErrorMessage && this.state.modalErrorMessage.length>0 && (
                                <Row className={'text-center'}>
                                  <Col sm={3} className="hidden-xs"/>
                                  <Col xs={12} sm={6} >
                                    <div className="validation-error" style={{textAlign: "center"}}>
                                      {this.state.modalErrorMessage}
                                    </div>
                                  </Col>
                                </Row>
                            )
                        }
                      </form>
                    </Modal.Body>
                    <Modal.Footer style={{justifyContent: 'space-between', flexWrap: 'nowrap'}}>
                      <Button variant="secondary" onClick={(e) => this.hideBene()}>
                        Cancel
                      </Button>
                      <Button id={'beneSaveBtn'} variant="primary" onClick={(e) => this.saveBene()}>
                        Save
                      </Button>
                    </Modal.Footer>
                  </Modal>
              )
          }
        
        </AppContentWrapper>
    
    );
    
  }
}

export default Benes;